import { render, staticRenderFns } from "./my_publications_tab.vue?vue&type=template&id=e98ea0f0"
import script from "./my_publications_tab.vue?vue&type=script&lang=js"
export * from "./my_publications_tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports